<template>
  <div class="index">
    <el-dialog title="温馨提示" :visible.sync="isPcShow" class="pcInfo" append-to-body :close-on-click-modal="false">
      <img style="width: 100%" src="../assets/info.png" />
    </el-dialog>
    <el-row style="overflow: hidden; width: 100%">
      <el-col :span="18" :offset="3">
        <div v-if="$store.state.orderStep == 1">
          <el-tabs type="border-card" style="margin-top: 50px">
            <el-tab-pane label="悦享套餐价格">
              <price title="悦享套餐价格"></price>
            </el-tab-pane>
            <el-tab-pane label="充值中心">
              <recharge title="充值中心"></recharge>
            </el-tab-pane>
          </el-tabs>
        </div>
        <div v-if="$store.state.orderStep == 2">
          <!--          c-->
          <i style="
              font-size: 24px;
              font-weight: 600;
              padding: 30px 0;
              cursor: pointer;
            " @click="handleOrderBack" class="el-icon-back"></i>
          <chose-pay v-if="!$store.state.isPackage"></chose-pay>
          <div v-else>
            <package-buy></package-buy>
          </div>
        </div>
      </el-col>
    </el-row>

    <div class="tip">
      <!-- <i @click="showTip" style="cursor:pointer;" class="el-icon-s-opportunity"></i> -->
      <img
        id="tipList"
        class="tipBtn"
        @click="showTip"
        src="../assets/tip-img.png"
        alt=""
      />
      <div class="list" v-if="isShow">
        <span @click="gotip3"
          ><img src="../assets/tip-icon1.png" />发工资条向导</span
        >
        <span @click="gotip2"
          ><img src="../assets/tip-icon2.png" />使用指南</span
        >
        <a
          target="view_window"
          href="http://wpa.qq.com/msgrd?v=3&uin=3179561760&site=qq&menu=yes"
          style="display: block"
          ><span><img src="../assets/tip-icon3.png" />联系客服QQ</span></a
        >
        <span style="position: relative" class="payroll_wx_Father"
          ><img src="../assets/wx.png" />
          <img class="payroll_wx" src="../assets/inquire_payroll_wx.jpg" />
          联系客服微信</span
        >
        <span style="position: relative" class="payroll_wx_Father"
          ><img src="../assets/workvx.png" />
          <img class="payroll_wx" src="../assets/workvxkf.jpg" />
          联系客服企业微信</span
        >
      </div>
    </div>

    <el-dialog title="使用方法" :visible.sync="isIntorShow" style="margin-top: -10vh;" :close-on-click-modal="false">
      <Carousel v-model="value1" :radius-dot="true" arrow="never" dots="none">
        <CarouselItem>
          <div class="demo-carousel" style="height:500px">
            <h4>1.选择发薪类型和时间后上传带有手机号和邮箱excel文件</h4>
            <img style="width:100%;height:100%" src="../assets/step1.gif" alt />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel" style="height:500px">
            <h4>2. 选择模板格式（自定义模板需要进行编辑并将左侧的工资条类别选入对应的单元格中)</h4>
            <img style="width:100%;height:100%" src="../assets/step4.gif" alt />
          </div>
        </CarouselItem>
        <CarouselItem>
          <div class="demo-carousel" style="height:500px">
            <h4>3. 查看示例工资条，核对数据正确后点击发送</h4>
            <img style="width:100%;height:100%" src="../assets/step3.gif" alt />
          </div>
        </CarouselItem>
      </Carousel>
      <div style="float:right;padding-top:30px;">
        <el-button type="success" v-show="value1!=0" class="next-btn" @click="value1==0?null:value1--">{{value1==0?'':'上一步'}}</el-button>
        <el-button type="success" class="next-btn" @click="handleToNext">{{value1!==2?'下一步':'关闭提示'}}</el-button>
      </div>
      <div style="clear:both"></div>
    </el-dialog>

  </div>

  </div>
</template>

<script>

import { Upload, Button, Carousel, CarouselItem, DatePicker } from "iview";

import buyHeader from '../components/buyHeader'
import price from '../components/price'
import order from '../components/order'
import recharge from '../components/recharge'
import packageBuy from '../components/packageBuy'
import chosePay from '../components/chosePay'
import axios from 'axios'


export default {
  name: 'index',
  components: {
    buyHeader,
    price,
    order,
    recharge,
    chosePay,
    packageBuy,
  },
  data () {
    return {
      menuList: [],
      windowWidth: document.documentElement.clientWidth,
      isPcShow: false,
      isShow: false,
      value1: 0,
      isIntorShow: false,

    }
  },
  methods: {
    showTip () {
      if (this.isShow) {
        this.isShow = false
      } else {
        this.isShow = true
      }
    },
    gotip2 () {
      window.open('https://help.joyousoa.com/')
      // window.location.href = "https://help.joyousoa.com/";
      // this.$router.push('help')
    },
    gotip3 () {
      window.localStorage.setItem('isIntorShow', false)
      this.value1 = 0
      this.isMovieShow = true
      this.$refs.video.play()
      this.$refs.video.currentTime = 0
    },
    handleToNext () {
      this.value1 < 2 ? this.value1++ : (this.isIntorShow = false)
    },
    handleOrderBack () {
      this.$store.commit('orderStepBack')
      this.$router.push({
        path: '/index/buy',
        query: {},
      })
    },
  },
  mounted () {
    if (this.windowWidth <= 768) {
      this.isPcShow = true
    } else {
      this.isPcShow = false
    }
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('orderStepBack')
    next()
  },
}
</script>

<style lang="less" scoped>
/deep/.is-active {
  background-color: #3bc492 !important;
  color: #fff !important;
}
.pcInfo {
  width: 100%;
  /deep/.el-dialog {
    width: 90%;
    margin: 0 5%;
    .el-dialog__body {
      padding: 0;
    }
  }
}
.tip {
  position: fixed;
  bottom: 5vh;
  right: 55px;
  font-size: 40px;
  .tipBtn {
    width: 80px;
    cursor: pointer;
  }
  .list {
    // position: absolute;
    // bottom: 40vh;
    // right:0px;
    position: absolute;
    top: -205px;
    right: -40px;
    width: 165px;
    font-size: 14px;
    color: #555;
    background: #fff;
    box-shadow: 0 0 6px rgba(59, 196, 146, 0.8);
    border-radius: 8px;
    padding: 20px 0;
    // display: none;
    .close {
      position: absolute;
      top: 5px;
      right: 5px;
      font-size: 20px;
      cursor: pointer;
    }
  }
  span {
    width: 100%;
    line-height: 38px;
    display: block;
    padding-left: 8px;
    cursor: pointer;
    display: flex;
    align-items: center;
    color: #666;
    img {
      width: 25px;
      padding-right: 5px;
    }
  }
  span:hover {
    background: rgba(89, 206, 164, 0.3);
    color: rgba(89, 206, 164);
  }
}
.payroll_wx_Father:hover {
  .payroll_wx {
    display: block;
  }
}
.payroll_wx {
  position: absolute;
  width: 200px !important;
  left: -200px;
  bottom: 0;
  display: none;
}
</style>
